import * as React from 'react'
import {
  FunnelChart as RechartFunnelChart,
  Funnel,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from 'recharts'

import { LegendTextFormatter } from 'components/Shared/Charts/LegendTextFormatter'
import { ChartTooltip } from 'components/Shared/Charts/ChartTooltip'
import styles from 'components/Shared/Charts/FunnelChart/FunnelChart.module.scss'
import { isMobileView } from 'lib/GlobalConstants'
import { formatNumbers } from 'lib/Helper'

type FunnelChartProps = {
  data: any[]
  dataKey: string
  labelKey: string
  title: string
}

const textFormatter = (_: string, entry: any) => {
  const { name, fill: color } = entry
  const translationKey = name?.toLowerCase() || ''

  return <LegendTextFormatter color={color} translationKey={translationKey} />
}

const customTooltip = (props: any | { payload: [] }, tooltipTitle: string) => {
  //tooltip data from recharts is in payload array, and its always the first object
  const tooltipData = props.payload[0]
  if (tooltipData) {
    const {
      name: engagementCategory,
      label: engagementValue,
      fill: dotColor,
    } = tooltipData.payload
    const [val, ...rest] = engagementValue.split(' ')
    const contentObj = {
      [engagementCategory]: `${formatNumbers(val)} ${rest}`,
    }

    return (
      <ChartTooltip
        title={tooltipTitle}
        dotColor={[dotColor]}
        content={contentObj}
      />
    )
  }

  return null
}

const renderCustomizedLabel = (payload: any) => {
  const { x, y, width, value } = payload
  const [val, ...rest] = value.split(' ')
  return (
    <foreignObject x={x + width + 15} y={y + 20} width="75" height="60">
      <span className={styles.labelText}>
        {formatNumbers(val)} {rest}
      </span>
    </foreignObject>
  )
}

const FunnelChart = ({ data, dataKey, labelKey, title }: FunnelChartProps) => {
  return (
    <ResponsiveContainer
      height={340}
      width={'90%'}
      className={styles.funnelChartContainer}
    >
      <RechartFunnelChart
        margin={{
          top: 0,
          right: 30,
          bottom: 0,
          left: 0,
        }}
      >
        <Tooltip content={(props) => customTooltip(props, title)} />
        <Legend
          iconType="circle"
          iconSize={0}
          payload={data}
          formatter={textFormatter}
          wrapperStyle={{ left: 0, bottom: 44 }}
          className={styles.legendResponsive}
          layout={isMobileView ? 'vertical' : 'horizontal'}
        />
        <Funnel
          dataKey={dataKey}
          data={data}
          isAnimationActive={false}
          lastShapeType="rectangle"
        >
          <LabelList dataKey={labelKey} content={renderCustomizedLabel} />
        </Funnel>
      </RechartFunnelChart>
    </ResponsiveContainer>
  )
}

export default FunnelChart
